import { checkAuthenticated, loginType } from "@/shared/utils";

import { RouteConfig } from "vue-router";

const authLayout = () => import("@/layouts/AuthLayout.vue");
const auth = () => import("../views/auth.vue");
const forgetPassword = () => import("../views/forget-password.vue");
const contactUs = () => import("../views/contact-us.vue");
const authMobile = () => import("../views/auth-mobile.vue");
const activeRegistrations = () =>
  import("../views/pre-register/active-registrations.vue");
const detailRegistrations = () =>
  import("../views/pre-register/detail-registrations.vue");
const personalInformation = () =>
  import("../views/pre-register/personal-information.vue");
const resultRegistrations = () =>
  import("../views/pre-register/result-registrations.vue");

export const authRoutes: RouteConfig[] = [
  {
    path: "/auth",
    name: "auth",
    redirect: loginType() === "send-code" ? "/auth/auth-mobile" : "/auth/login",
    component: authLayout,
    children: [
      {
        path: "login",
        name: "auth",
        component: auth,
        beforeEnter: async (to: any, from: any, next: any) => {
          const isAuthenticated = await checkAuthenticated();
          if (isAuthenticated) {
            next({
              name: "dashboard",
            });
          } else {
            next();
          }
        },
        meta: {
          deprecated: true,
          label: "ورود",
        },
      },
      {
        path: "forget-password",
        name: "forget-password",
        component: forgetPassword,
        meta: {
          deprecated: true,
          label: "فراموشی رمز عبور",
        },
      },
      {
        path: "contact-us",
        name: "contact-us",
        component: contactUs,
        meta: {
          deprecated: true,
          label: "ثبت مشکل ورود",
        },
      },
      {
        path: "auth-mobile",
        name: "auth-mobile",
        component: authMobile,
        meta: {
          deprecated: true,
          label: "ورود با رمز یکبار مصرف",
        },
      },
    ],
  },
  {
    path: "/pre-register",
    name: "pre-register",
    redirect: "/pre-register/active-registrations",
    component: authLayout,
    children: [
      {
        path: "active-registrations",
        name: "active-registrations",
        component: activeRegistrations,
        meta: {
          deprecated: true,
          label: "ثبت نام",
        },
      },
      {
        path: "detail-registrations/:code",
        name: "detail-registrations",
        component: detailRegistrations,
        meta: {
          deprecated: true,
          label: "ثبت نام",
        },
      },
      {
        path: "personal-information",
        name: "personal-information",
        component: personalInformation,
        meta: {
          deprecated: true,
          label: "ثبت نام",
        },
      },
      {
        path: "result-registrations",
        name: "result-registrations",
        component: resultRegistrations,
        meta: {
          deprecated: true,
          label: "ثبت نام",
        },
      },
    ],
  },
];
